export default __webpack_public_path__ + "static/media/floor9.d497af67.png";